module.exports = __webpack_public_path__ + "img/dcmm_17.13c8ea87.png";